const useStyles = (props) => {
    const { tableCollapseMaxWidth } = props;
    const tableCollapseBreakpoint = [`@media (max-width: ${tableCollapseMaxWidth})`];
    return {
        historyTable: {
            "& table, thead, tbody, th, td, tr": {
                [`${tableCollapseBreakpoint}`]: { /* force table to not be a table anymore */
                    display: "block"
                }
            },
            "& thead tr": {
                [`${tableCollapseBreakpoint}`]: { /* hide table headers (without using display, to support accessibility) */
                    left: "-9999px",
                    position: "absolute",
                    top: "-9999px"
                }
            },
            "& tr": {
                [`${tableCollapseBreakpoint}`]: {
                    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                    paddingBottom: "1rem",
                    paddingTop: "1rem"
                }
            },
            "& td.noHeader": {
                paddingLeft: "0rem !important"
            },
            "& td:not(.noHeader)": {
                overflowWrap: "break-word",
                padding: "4px",
                [`${tableCollapseBreakpoint}`]: { /* behave like a row */
                    borderBottom: 0,
                    marginTop: "0.1rem",
                    marginBottom: "0.1rem",
                    minHeight: "2rem",
                    paddingLeft: "8rem",
                    position: "relative",
                    textAlign: "left",
                    width: "100%"
                }
            },
            "& td:before": {
                [`${tableCollapseBreakpoint}`]: { /* behave like a table header */
                    content: "attr(data-header)",
                    fontWeight: 600,
                    left: "0rem",
                    position: "absolute",
                    whiteSpace: "nowrap"
                }
            }
        }
    };
};

export default useStyles;